import { Box, Tooltip } from "@mui/material";
import { TooltipProps } from "@mui/material/Tooltip/Tooltip";
import { useInputChoicesContext } from "misc/customHooks";
import { getEventStatusColor, getEventStatusIcon } from "misc/formatHelpers";
import { useRecordContext, useTranslate } from "react-admin";

import { EventStatusEnum } from "../pages/Event/Event.types";
import StatusChip from "./StatusChip";

export type EventChipableRecordType = {
  status: EventStatusEnum;
  id_number: string;
};

type EventChipPropsType = {
  value?: string;
  clickable?: boolean;
  eventGroupName?: string;
  showStatus?: boolean;
  size?: "small" | "medium";
  tooltipTitle?: string;
  tooltipProps?: TooltipProps;
  showTooltip?: boolean;
  status?: EventStatusEnum;
  event?: { status: EventStatusEnum; id_number: string };
  disabled?: boolean;
};

export default function EventChip(props: EventChipPropsType) {
  const {
    clickable,
    eventGroupName,
    value,
    showStatus,
    size,
    tooltipTitle,
    tooltipProps = {},
    showTooltip = true,
    status,
    event,
    disabled,
  } = props;
  const record = useRecordContext<EventChipableRecordType>();
  const finalRecord = event ? event : record;
  const translate = useTranslate();

  const statusChoices = useInputChoicesContext("event_statuses");

  if (!finalRecord && !value) return null;

  const finalStatus = status ? status : finalRecord ? finalRecord.status : EventStatusEnum.Draft;
  const statusChoice = statusChoices.find((s) => (s.value as EventStatusEnum) === finalStatus);

  const color = getEventStatusColor(finalStatus);
  const StatusIcon = getEventStatusIcon(finalStatus);

  const statusTooltipTitle = statusChoice ? "hints.event_status_label" : "";

  const finalLabel = value ? value : finalRecord?.id_number;

  const icon = showStatus ? <StatusIcon style={{ color, width: 24, height: 24 }} /> : undefined;

  const finalTooltipTitle = eventGroupName
    ? `${translate(tooltipTitle || "")}: ${eventGroupName}`
    : tooltipTitle
      ? tooltipTitle
      : translate(statusTooltipTitle, { status: statusChoice?.name });

  const chip = (
    <span>
      <StatusChip clickable={disabled ? false : clickable} size={size} icon={icon} label={finalLabel} />
    </span>
  );

  return (
    <Box sx={{ display: "flex" }}>
      {showTooltip ? (
        <Tooltip title={finalTooltipTitle} placement="top" {...tooltipProps}>
          {chip}
        </Tooltip>
      ) : (
        chip
      )}
    </Box>
  );
}
